import { render, staticRenderFns } from "./Schemi.vue?vue&type=template&id=1d782380&scoped=true&"
import script from "./Schemi.vue?vue&type=script&lang=js&"
export * from "./Schemi.vue?vue&type=script&lang=js&"
import style0 from "./Schemi.vue?vue&type=style&index=0&id=1d782380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d782380",
  null
  
)

export default component.exports